<div class="sso-page">
    <app-loading [isLoading]="true" />
</div>
